import React from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';
import data from '../data.json';

const Gallery = () => {
  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Gallery
      </Typography>
      <Grid container spacing={2}>
        {data.galleryImages.map((src, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box
              component="img"
              src={src}
              alt={`Gallery ${index + 1}`}
              sx={{ width: '100%', borderRadius: 2 }}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Gallery;
